import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonVariant } from '../../deprecated-button/button';
import { IconName } from '../../icon/icon';
import Modal, { ModalVariant } from '../modal/modal';

export interface LoseChangesModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LoseChangesModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: LoseChangesModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      title={t('loseProgress.loseProgressTitle', {
        defaultValue: 'Are you sure you want to leave this page?',
      })}
      description={t('loseProgress.title', {
        defaultValue: 'By leaving you will lose all your progress.',
      })}
      primaryText={t('loseProgress.accept', {
        defaultValue: 'Yes, lose progress',
      })}
      primaryVariant={ButtonVariant.error}
      secondaryText={t('words.cancel', { defaultValue: 'Cancel' })}
      onConfirm={onConfirm}
      onClose={onCancel}
      icon={IconName.Alert}
      variant={ModalVariant.Icon}
      height="fit-content"
    />
  );
};

export default memo(LoseChangesModal) as typeof LoseChangesModal;
